<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getPartnerCompanyList" :filter="filter"
    :min-search-char-limit="0" :allow-create="allowCreate" :externaledit="externaledit" :clearable="clearable"
    :multiple="multiple" :returnobject="returnobject" :disabled="disabled" :loading="loading"
    valuekey="Id" textkey="CompanyName"
    :label="label ? label : $t('servicesystem.common_objects.partner_company.partner_company')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.partner_company.search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$partner_company</v-icon>
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "PartnerCompanySelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    allowCreate: Boolean,
    hideIcon: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      resetKey: 1,
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>